import { Box, Heading, Paragraph } from 'grommet'
import styled, { css } from 'styled-components'

import { NormalizedWrapper } from '@theme'

export const Wrapper = styled(NormalizedWrapper)`
  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl5}px;

    ${theme.below.laptop`
      padding: 0 ${theme.newSpaces.sm}px;
    `}

    ${theme.below.tablet`
      justify-content: center;
      margin-top: ${theme.newSpaces.xl2}px;
    `}

    ${theme.below.mobileXL`
      padding: 0 ${theme.newSpaces.xl}px;
      margin-top:${theme.newSpaces.xl2}px;
      margin-bottom:-${theme.newSpaces.xl3}px;
    `}
  `}
`

export const Cards = styled(Box)`
  column-gap: 20px;
  flex-direction: row;
  flex-wrap: wrap;
  justify-content: space-between;
  width: 100%;

  ${({ theme }) => css`
    margin-top: ${theme.newSpaces.xl10}px;

    ${theme.below.tablet`
      justify-content: center;
      margin-top: ${theme.newSpaces.xl2}px;
    `}
  `}
`

export const Card = styled(Box)`
  width: 30%;

  ${({ theme }) => css`
    align-items: center;

    ${theme.below.tabletL`
      width: 100%;
      margin-bottom: ${theme.newSpaces.md}px;

    `}

    ${theme.below.tabletS`
      width: 100%;
    `}
  `}
`

export const TableTitle = styled(Heading)`
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  text-align: center;
  width: fit-content;

  ${({ theme }) => css`
    ${theme.getTypography('desktop', 'title', 'large')}

    background-image: ${theme.newColors.gradientGreen};

    ${theme.below.tablet`
      margin: 0 auto;
    `}
  `}
`

export const TableSubtitle = styled(Paragraph)`
  text-align: center;
  text-transform: uppercase;
  white-space: pre-wrap;
  width: 100%;

  ${({ theme }) => css`
    ${theme.getTypography('mobile', 'title', 'blog')};

    color: ${theme.newColors.primary};
    margin: ${theme.newSpaces.md}px auto 0;
  `}
`
